module.exports = __webpack_public_path__ + "img/73.3.TP.e972dc68.png";